import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Col, ControlLabel, Panel, Row, Table, Tooltip, Whisper } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import AppContext from '../../context/AppContext'
import classNames from 'classnames'
import InputForm from '../../components/forms/input/InputForm'
import {
  getFinancialReport,
  saveWithdrawBankAccAmt,
} from '../../redux/actions/subProjectFinancialReport'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import NumberFormat from 'react-number-format'

export default function ExpenditBreakdownByActivitiesWidget({
  schema: _schema,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  statusOnSave = () => {},
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    // console.log('formSchema => ', formSchema)
    // console.log('disableddisableddisableddisabled =>', disabled)
    setFormSchema(_schema)
  }, [_schema])

  const onSubmit = async (data) => {
    console.log('onSubmit => ', data)

    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const request = {
        projectVersionId,
        projectCode,
        period,
        installmentPlanDetailId: installmentPlanId,
        id: formSchema?.withdrawInput?.id || '',
        withdrawForBankAccountAmt: data?.withdrawInput || 0,
      }

      let response = await saveWithdrawBankAccAmt(request)

      // console.log('response => ', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        handleGetSchema()
        statusOnSave(true)
      } else {
        setIsError(true)
        statusOnSave(false)
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
      })

      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const _schema = await getFinancialReport(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      setFormSchema(_schema.forms.projectActivity)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
  }

  return (
    <>
      {formSchema && (
        <Panel shaded header={formSchema.header} collapsible defaultExpanded>
          <Table minHeight={150} autoHeight data={formSchema.value}>
            <Column width={350} align="left">
              <HeaderCell>กิจกรรม</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.id == 'total') {
                    return <b>รวม</b>
                  }

                  if (rowData?.activity && rowData?.activity?.length >= 40) {
                    return (
                      <Whisper
                        placement="right"
                        trigger="hover"
                        speaker={<Tooltip>{rowData.activity}</Tooltip>}
                      >
                        <p>{rowData.activity ? `${rowData.activity.substring(0, 40)}...` : ''}</p>
                      </Whisper>
                    )
                  }

                  return rowData.activity
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>ค่าตอบแทน</HeaderCell>
              <Cell>
                {(rowData) => {
                  // if (!rowData.compensation) {
                  //   return ''
                  // }

                  if (rowData.id == 'total') {
                    return <b>{budgetFormat(rowData.compensation)}</b>
                  }

                  return budgetFormat(rowData.compensation)
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>ค่าจ้าง</HeaderCell>
              <Cell>
                {(rowData) => {
                  // if (!rowData.wages) {
                  //   return ''
                  // }

                  if (rowData.id == 'total') {
                    return <b>{budgetFormat(rowData.wages)}</b>
                  }

                  return budgetFormat(rowData.wages)
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>ค่าใช้สอย</HeaderCell>
              <Cell>
                {(rowData) => {
                  // if (!rowData.expenses) {
                  //   return ''
                  // }

                  if (rowData.id == 'total') {
                    return <b>{budgetFormat(rowData.expenses)}</b>
                  }

                  return budgetFormat(rowData.expenses)
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>ค่าวัสดุ</HeaderCell>
              <Cell>
                {(rowData) => {
                  // if (!rowData.materialCost) {
                  //   return ''
                  // }

                  if (rowData.id == 'total') {
                    return <b>{budgetFormat(rowData.materialCost)}</b>
                  }

                  return budgetFormat(rowData.materialCost)
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>ค่าสาธารณูปโภค</HeaderCell>
              <Cell>
                {(rowData) => {
                  // if (!rowData.utilityCosts) {
                  //   return ''
                  // }

                  if (rowData.id == 'total') {
                    return <b>{budgetFormat(rowData.utilityCosts)}</b>
                  }

                  return budgetFormat(rowData.utilityCosts)
                }}
              </Cell>
            </Column>

            <Column width={180} align="right">
              <HeaderCell>รายจ่ายอื่นๆ</HeaderCell>
              <Cell>
                {(rowData) => {
                  // if (!rowData.otherExpenses) {
                  //   return ''
                  // }

                  if (rowData.id == 'total') {
                    return <b>{budgetFormat(rowData.otherExpenses)}</b>
                  }

                  return budgetFormat(rowData.otherExpenses)
                }}
              </Cell>
            </Column>

            <Column width={180} align="right" fixed={'right'}>
              <HeaderCell>รวมรายจ่าย</HeaderCell>
              <Cell>
                {(rowData) => {
                  // if (!rowData.total) {
                  //   return ''
                  // }

                  return <b>{`${budgetFormat(rowData.total)}`}</b>
                }}
              </Cell>
            </Column>
          </Table>

          <Row style={{ marginTop: 20 }}>
            <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
              <div style={{ marginTop: 16 }}>
                <ControlLabel
                  className={classNames(
                    isRequired(formSchema.withdrawInput.validators) && 'required'
                  )}
                >
                  {formSchema.withdrawInput.label}
                </ControlLabel>
              </div>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12} style={{ textAlign: 'right' }}>
              <Controller
                name={formSchema.withdrawInput.name}
                control={control}
                defaultValue={formSchema.withdrawInput.value || 0}
                // rules={isRequired ? { required: 'กรุณากรอกจำนวนเงิน' } : {}}
                rules={isValidators(formSchema.withdrawInput.validators)}
                render={(props) => {
                  return (
                    <NumberFormat
                      style={{
                        textAlign: 'right',
                        fontWeight: 'bold',
                      }}
                      className={classNames(
                        'rs-input',
                        errors[formSchema.withdrawInput.name] && 'is-error'
                      )}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale
                      value={props.value}
                      onValueChange={(value) => {
                        props.onChange(value.floatValue)
                      }}
                      disabled={disabled}
                    />
                  )
                }}
              />
              {/* <InputForm
                schema={formSchema.withdrawInput}
                register={register}
                placeholder={formSchema.withdrawInput.placeholder}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel={true}
                isInputNumber
                inputStyle={{ textAlign: 'right' }}
                disabled={disabled}
                onChange={(value) => {
                  console.log('value => ', value)
                }}
              /> */}
            </Col>

            <Col lg={6} md={6} sm={6} xs={6}>
              <div style={{ marginTop: 16 }}>{formSchema.withdrawInput.unit}</div>
            </Col>
          </Row>

          {!disabled && (
            <Row style={{ marginTop: 20 }}>
              <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                  <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                    บันทึก
                  </SaveButton>
                </div>
              </Col>
            </Row>
          )}
        </Panel>
      )}
    </>
  )
}
